import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import { useScreenSizeContext } from '@/components/ScreenSize.context';
import {
  formatVideoPresentationData,
  isEspotHtml,
  isEspotImageInfoCardList,
  isEspotInfoCardList,
  isEspotListSample,
  isEspotVideo,
  isEspotDisplayed,
  isEspotDuoList
} from '@/utils/homepageUtils';

import DuoCardList from '@/components/common/InfoCardList/DuoCardList';
import ImageCardList from '@/components/common/ImageCardList';
const ImageInfoCardList = dynamic(() => import('@/components/common/ImageInfoCardList'));
ImageInfoCardList.displayName = 'DynamicLayout';
import EspotList from '@/components/common/InfoCardList/EspotList';
import VideoPresentation from '@/components/common/VideoPresentation';
import HtmlESpot from '@/components/layout/espots/HtmlESpot';

import styles from './DynamicLayout.module.scss';

export const DynamicLayout = ({ componentList, isMobileDevice, withPadding = true, lazy = false }) => {
  const { isMobile, mappedBreakpoint: breakpoint } = useScreenSizeContext();

  const isFullWidth = (espot) => isEspotVideo(espot) || isEspotHtml(espot);
  return componentList?.length > 0 ? componentList.map((cmpt) => {
    const espot = cmpt?.espot;

    const computedClass = [
      isFullWidth(espot) ? styles['full-width'] : styles['max-width'],
      withPadding && styles[`padding-${breakpoint}`],
      isEspotImageInfoCardList(espot) && styles['espot-card-list']
    ].filter(Boolean).join(' ');

    return isEspotDisplayed(espot, isMobileDevice) ? (
      <div className={computedClass} key={espot._id}>
        {isEspotHtml(espot) && (
          <HtmlESpot data={espot} />
        )}
        {isEspotImageInfoCardList(espot) && (
          <ImageInfoCardList data={espot} breakpoint={breakpoint} lazy={lazy} />
        )}
        {isEspotInfoCardList(espot) && (
          <EspotList data={espot} />
        )}
        {isEspotDuoList(espot) && !isMobile && (
          <DuoCardList data={espot} />
        )}
        {isEspotListSample(espot) && (
          <ImageCardList data={espot} breakpoint={breakpoint} />
        )}
        {isEspotVideo(espot) && (
          <VideoPresentation data={formatVideoPresentationData(espot)} breakpoint={breakpoint} />
        )}
      </div>
    ) : null;
  }) : null;
};

DynamicLayout.propTypes = {
  componentList: PropTypes.array,
  isMobileDevice: PropTypes.bool,
  withPadding: PropTypes.bool,
  lazy: PropTypes.bool
};

export default DynamicLayout;
